import VGListener from "../src/vg";

/*addEventListener("turbo:load", (event) => {
	console.log('turbo:load');
});*/

document.addEventListener("turbo:render", (event) => {
	if (event.target?.hasAttribute('data-turbo-preview') === true) return;
	VGListener.onReady();
});

